import {
    CHANGE_SCRIPT_REQUEST,
    CHANGE_SCRIPT_RESULT,
    CHANGE_SCRIPT_OPEN_MODAL,
    CHANGE_SCRIPT_CLOSE_MODAL,
    CHANGE_SCRIPT_GET_DEVICE_REQUEST,
    CHANGE_SCRIPT_GET_DEVICE_RESULT,
    CHANGE_SCRIPT_SET_DEVICE,
    CHANGE_SCRIPT_GET_SCRIPTS,
    CHANGE_SCRIPT_GET_SCRIPTS_RESULTS,
} from 'Redux/actionTypes';

export const changeScriptRequest = (data) => ({
    type: CHANGE_SCRIPT_REQUEST,
    payload: data
})

export const changeScriptResult = (result) => ({
    type: CHANGE_SCRIPT_RESULT,
    payload: result
})

export const changeScriptOpenModal = (devices) => ({
    type: CHANGE_SCRIPT_OPEN_MODAL,
    payload: { devices }
})

export const changeScriptCloseModal = () => ({
    type: CHANGE_SCRIPT_CLOSE_MODAL
})

export const changeScriptGetDeviceRequest = (devices) => ({
    type: CHANGE_SCRIPT_GET_DEVICE_REQUEST,
    payload: { devices }
})

export const changeScriptGetDeviceResult = (result) => ({
    type: CHANGE_SCRIPT_GET_DEVICE_RESULT,
    payload: result
})

export const changeScriptSetDevice = (device) => ({
    type: CHANGE_SCRIPT_SET_DEVICE,
    payload: device
})

export const changeScriptGetScritps = (data) => ({
    type: CHANGE_SCRIPT_GET_SCRIPTS,
    payload: { data: data }
})

export const changeScriptGetScritpsResult = (result) => ({
    type: CHANGE_SCRIPT_GET_SCRIPTS_RESULTS,
    payload: result
})